/**
 * @generated SignedSource<<30eeba81ca5d7ba5967f06a030b973a5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TodoEditNewMainStoreTitleAndDescription_todo$data = {
  readonly body: string | null;
  readonly canWrite: boolean;
  readonly id: string;
  readonly isIssue: boolean;
  readonly title: string;
  readonly " $fragmentSpreads": FragmentRefs<"TodoEditNewMainCreationInfo">;
  readonly " $fragmentType": "TodoEditNewMainStoreTitleAndDescription_todo";
};
export type TodoEditNewMainStoreTitleAndDescription_todo$key = {
  readonly " $data"?: TodoEditNewMainStoreTitleAndDescription_todo$data;
  readonly " $fragmentSpreads": FragmentRefs<"TodoEditNewMainStoreTitleAndDescription_todo">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TodoEditNewMainStoreTitleAndDescription_todo",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TodoEditNewMainCreationInfo"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "body",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canWrite",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isIssue",
      "storageKey": null
    }
  ],
  "type": "Todo",
  "abstractKey": null
};

(node as any).hash = "5dcaae084273fb9ecfde610a8fd8ff68";

export default node;
